import {
  animate,
  AnimationBuilder,
  AnimationFactory,
  style,
} from "@angular/animations";
import {
  AfterViewInit,
  Component,
  ContentChildren,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  QueryList,
  Renderer2,
  ViewChild,
  ViewChildren,
} from "@angular/core";

import {
  CarouselEditItemDirective,
  CarouselEditItemElementDirective,
} from "../carousel-edit/carousel-edit-item.directive";

import { PostFileMediaType } from "../../../../../shared/enums/campaignPost.enums";

@Component({
  selector: "app-carousel-preview",
  exportAs: "app-carousel-preview",
  templateUrl: "./carousel-preview.component.html",
  styleUrl: "./carousel-preview.component.scss",
})
export class CarouselPreviewComponent implements OnInit, AfterViewInit {
  @Input() public itemSizePx = 72;
  @Input() public numVisibleItems = 5;
  @Input() public showControls = true;
  @Input() public timing = "350ms ease-in";

  @Output() public itemSelected = new EventEmitter<number>();

  @ContentChildren(CarouselEditItemDirective)
  protected items!: QueryList<CarouselEditItemDirective>;
  @ViewChildren(CarouselEditItemElementDirective, { read: ElementRef })
  private itemsElements!: QueryList<ElementRef>;
  @ViewChild("carousel")
  private carousel!: ElementRef;

  protected readonly PostFileMediaType = PostFileMediaType;
  protected currentSlide = 0;
  protected buttonSizePx = 18;

  constructor(
    private readonly builder: AnimationBuilder,
    private readonly renderer: Renderer2,
  ) {}

  public ngOnInit(): void {
    this.buttonSizePx = this.itemSizePx / 4;
  }

  public ngAfterViewInit(): void {
    if (this.itemsElements && this.itemsElements.length) {
      this.renderer.addClass(this.itemsElements.first.nativeElement, "current");
    }
  }

  private buildAnimation(offset: number): AnimationFactory {
    return this.builder.build([
      animate(this.timing, style({ transform: `translateX(-${offset}px)` })),
    ]);
  }

  protected next(): void {
    if (this.currentSlide + this.numVisibleItems === this.items.length) {
      return;
    }

    this.currentSlide = (this.currentSlide + 1) % this.items.length;
    this.animate();
  }

  protected prev(): void {
    if (this.currentSlide === 0) {
      return;
    }

    this.currentSlide =
      (this.currentSlide - 1 + this.items.length) % this.items.length;
    this.animate();
  }

  private goToSlide(index: number): void {
    this.currentSlide = index;
    this.animate();
  }

  public goToEnd(): void {
    if (this.items.length > this.numVisibleItems) {
      this.goToSlide(this.items.length - (this.numVisibleItems - 1));
    }
  }

  private animate(): void {
    const itemWidth =
      this.itemsElements.first.nativeElement.getBoundingClientRect().width;
    const offset = (itemWidth + 8) * this.currentSlide;
    const player = this.buildAnimation(Math.abs(offset)).create(
      this.carousel.nativeElement,
    );

    player.play();

    // Mark all items as current before the animation
    this.itemsElements.map((item) => {
      this.renderer.addClass(item.nativeElement, "current");
    });

    player.onDone(() => {
      this.itemsElements.map((item, index) => {
        if (this.currentSlide !== index) {
          // Remove class current to all items but the actual current one
          this.renderer.removeClass(item.nativeElement, "current");
        }
      });
    });
  }
}
